// pages/DashboardPage.js
import React from "react";
import Sidebar from "../components/UserSidebar";
import ProfileHeader from "../components/ProfileHeader";
import UserDashboard from "../components/Userdashboard";

const DashboardPage = () => {
  // Prefer per-tab sessionStorage; fallback to shared localStorage
  let user = { name: "Guest", username: "guest" };
  try {
    const stored = sessionStorage.getItem("currentUser");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.role === "user") user = { name: parsed.username, username: parsed.username };
    } else {
      const local = JSON.parse(localStorage.getItem("user") || "null");
      if (local) user = local;
    }
  } catch (e) {
    // keep default
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <ProfileHeader />
        <UserDashboard user={user} /> 
      </div>
    </div>
  );
};

export default DashboardPage;
